import { useEffect } from "react";

import { hideMessenger, showMessenger } from "./messengerUtils";

export const useHideMessenger = (active: boolean): void => {
  useEffect(() => {
    if (!active) return undefined;
    hideMessenger();
    return showMessenger;
  }, [active]);
};
